module.exports = __webpack_public_path__ + "static/media/display-suite-03.d5e0cae5.png";